
<script>
import OwalButton from './OwalButton'

export default {
  name: 'OwalBannerButton',
  components: {
    OwalButton,
  },
  extends: OwalButton,
  props: {
    /**
     * Valid values:
     *  - `none`: no chevron
     *  - `static`: chevron is present but does not animate.
     *  - `dynamic`: The chevron is present and alternates position based on button state.
     */
    accessoryType: {
      type: String,
      default: 'static',
      validation: function (newValue) {
        const validValues = ['none', 'static', 'dynamic']
        const valid = validValues.includes(newValue)

        if (!valid) {
          console.log(`OwalScrollContainer.vue: Valid values are ${validValues.join(',')}`)
        }

        return valid
      },
    },
  },
}
</script>

<style scoped>
.owal-banner-button__container_default,
.owal-banner-button__container_destructive {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;

  padding: 0.3571428571rem;
  cursor: pointer;
  transition: background-color 300ms ease, transform 300ms ease, opacity 250ms ease;
  overflow: hidden;
  border: 2px solid #E0E0E0;
  background: #F0F0F0;
}

.owal-banner-button__container_destructive,
.owal-banner-button__container_destructive a {
  color: rgba(208,2,27, 0.9);
}

/** Default style hover. */
.owal-banner-button__container_default,
.owal-banner-button__container_default a{
  color: #324057;
}

.owal-banner-button__container_default:hover {
  background: #F3F4F5;
}

/** All Button Types Hover */
.owal-banner-button__container_default:hover,
.owal-banner-button__container_destructive:hover {
  transform: scale(1.05);
  opacity: 0.75;
}

.owal-banner-button__text {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-grow: 1;
}

/* Title: */
.owal-banner-button__title_left,
.owal-banner-button__title_right,
.owal-banner-button__title_center {
  font-family: 'Lato-Regular', 'Avenir';
  font-size: 1rem;
  letter-spacing: 0;
  padding: 0;
  margin: 0;
}

/* Subtitle: */
.owal-banner-button__subtitle_left,
.owal-banner-button__subtitle_right,
.owal-banner-button__subtitle_center {
  font-family: 'Lato-Italic', 'Avenir', sans-serif;
  font-size: 0.8571428571rem;
  color: #8492A6;
  letter-spacing: 0;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 28rem;
  overflow: hidden;
}

.owal-banner-button__title_left,
.owal-banner-button__subtitle_left {
  text-align: left;
  align-self: flex-start;
}

.owal-banner-button__subtitle_right,
.owal-banner-button__title_right {
  text-align: right;
  align-self: flex-end;
}

.owal-banner-button__title_center,
.owal-banner-button__subtitle_center {
  text-align: center;
  align-self: center;
}

/** Acessory */
.owal.banner.button.accessory {
  flex-direction: column;
  width: 0.7142857143rem;
  height: 100%;
  flex-shrink: 0;

  justify-content: center;
  align-content: center;
  align-items: center;
  margin-left: 0.71428571rem;
}

/* Chevron accessory */
.chevron {
  height: 0.7857142857rem;
  width: 0.4285714286rem;
  margin-right: 015rem;
  transition: transform 300ms ease;
  transform: initial;
}

.chevron.rotated {
  transform: translate(0, 0.15rem) rotateZ(90deg);
}

</style>
